// project imports
import Navigation from "./Navigation";
import SimpleBar from "components/third-party/SimpleBar";
import {useGetMenuMaster} from "app/menu";

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
    const {menuMaster} = useGetMenuMaster();
    const drawerOpen = menuMaster.isDashboardDrawerOpened;

    return (
        <>
            <SimpleBar
                sx={{
                    "& .simplebar-content": {display: "flex", flexDirection: "column"},
                }}
            >
                <Navigation/>
            </SimpleBar>
        </>
    );
}
